import { rem } from '@heathmont/moon-utils';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import media from '~/client/shared/media';

type WithTheme = { theme: Theme };

const baseStyle = ({ theme }: WithTheme) => css`
  overflow: hidden;
  font-size: ${rem(24)};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${rem(32)};
  max-height: ${rem(64)};
  margin-top: 0;
  margin-bottom: ${rem(14)};
  ${media.desktopSmall} {
    max-height: ${rem(96)};
  }
`;

const bigStyle = ({ theme }: WithTheme) => css`
  ${media.desktopSmall} {
    font-size: ${rem(32)};
    font-weight: ${theme.fontWeight.semibold};
    line-height: ${rem(40)};
    margin: 0;
    max-height: ${rem(120)};
  }
`;

const smallStyle = ({ theme }: WithTheme) => css`
  font-size: ${rem(18)};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${rem(28)};
  max-height: ${rem(56)};
  margin-bottom: ${rem(8)};
  ${media.desktopSmall} {
    max-height: ${rem(84)};
  }
`;

const landscapeStyle = ({ theme }: WithTheme) => css`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  max-height: 4 ${rem(8)};
  margin-bottom: 8x;
  ${media.desktopSmall} {
    font-size: ${rem(18)};
    font-weight: ${theme.fontWeight.semibold};
    line-height: ${rem(28)};
  }
`;
const sliderStyle = ({}: WithTheme) => css`
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  max-height: ${rem(60)};
  margin-bottom: ${rem(8)};
`;

type LayoutProps = {
  size: 'big' | 'small';
  type: string;
  children: React.ReactNode;
};

const CONTAINER_STYLES: Record<
  string,
  (props: WithTheme) => FlattenSimpleInterpolation
> = {
  landscape: landscapeStyle,
  slider: sliderStyle,
};

const SIZE_STYLES = {
  big: bigStyle,
  small: smallStyle,
};

const Title = styled.h2((props: LayoutProps) => [
  baseStyle,
  CONTAINER_STYLES[props.type],
  SIZE_STYLES[props.size],
]);

export default Title;
